import React, { useCallback, useMemo } from "react";
import {
  AttachmentsList,
  OrderedList,
  StickableContent,
} from "shared/components";
import { useTabsState } from "shared/components/Tabs/Tabs.hooks";

import styles from "../Content007.module.scss";

export const Documents = ({ documents, attachments }) => {
  const { activeTab } = useTabsState();

  const filterByCourseSlug = useCallback(
    ({ course }) => course?.title === activeTab,
    [activeTab]
  );

  const filteredAttachments = useMemo(() => {
    return attachments.filter(filterByCourseSlug);
  }, [attachments, filterByCourseSlug]);

  const filteredDocuments = useMemo(() => {
    return documents.filter(filterByCourseSlug);
  }, [documents, filterByCourseSlug]);

  return (
    <div className={styles.documents}>
      <StickableContent>
        <AttachmentsList items={filteredAttachments} />
      </StickableContent>
      <div className={styles.list}>
        <OrderedList items={filteredDocuments} appearance="small" />
      </div>
    </div>
  );
};
